export default "__VITE_ASSET__BX19As1B__"